"use strict";

/* Extend the existing membership cart cleanup with Liquid-resolved variant access. */
(function () {
  let pending;
  const root = window.Shopify?.routes?.root || '/';
  async function cleanup() {
    const response = await fetch(`${root}?section_id=hunt-cart-access`, {
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Unable to check Hunt cart access');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const state = JSON.parse(html.querySelector('[data-hunt-cart-access]').textContent);
    if (state.hasAccess || !state.restrictedKeys.length) return;

    // Recheck the actual cart before removal, in case membership was just re-added.
    const cartResponse = await fetch(`${root}cart.js`, {
      cache: 'no-store'
    });
    if (!cartResponse.ok) throw new Error('Unable to refresh cart');
    const cart = await cartResponse.json();
    if (cart.items.some(item => String(item.variant_id) === '44168397324528')) return;
    const updates = {};
    cart.items.forEach(item => {
      if (state.restrictedKeys.includes(item.key)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    const removed = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates
      })
    });
    if (!removed.ok) throw new Error('Unable to remove member-only items');
    await window.Boost?.Cart?.refresh?.();
    document.dispatchEvent(new CustomEvent('cs:member:products:auto-removed', {
      detail: {
        removedCount: Object.keys(updates).length,
        originalCount: state.restrictedKeys.length
      }
    }));
  }
  window.CSHuntCart = {
    cleanup() {
      if (!pending) pending = cleanup().catch(error => console.error('[Hunt cart]', error)).finally(() => {
        pending = null;
      });
      return pending;
    }
  };
  document.addEventListener('cs:membership:statechange', event => {
    const items = event.detail?.cartData?.items;
    if (items?.length && !items.some(item => String(item.variant_id) === '44168397324528')) window.CSHuntCart.cleanup();
  });
  document.addEventListener('DOMContentLoaded', () => window.CSHuntCart.cleanup());
})();